import { agentInformation, modifyInfo, operatorList, operatorStatus, editOperator, addOperator } from '@/api/accountInfo'
// import { $dayFormat } from '@/utils/fn'
const state = {
  baseInfo: {
    agency_name: '',
    idcard: '', // 身份证号
    duty: '',
    legal: '',
    mobile: '',
    email: 'liuya@021.com',
    name: 'ly',
    nature: '',
    industry: '互联网',
    address: '大阿达',
    tel: '2313213',
    license: [], // 营业执照
    contract: [], // 业务合同
    idcardinfo: [] // 身份证信息
  },
  tableData: [],
  queryControl: {
    keyword: '',
    account: ''
  },
  pageControl: {
    pageNumber: 1,
    pageSize: 10,
    total: 0
  }
}
const getters = {
  baseInfo: state => state.baseInfo,
  tableData: state => state.tableData,
  pageControl: state => state.pageControl,
  queryControl: state => state.queryControl
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 企业资料
  agentInformation({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await agentInformation(params)
      if (code === 200) {
        commit('save', {
          baseInfo: {
            ...state.baseInfo,
            ...data,
            nature: !data.nature ? '' : data.nature
          }
        })
        resolve()
      }
    })
  },
  // 修改企业资料
  modifyInfo({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await modifyInfo(params)
      console.log(res)
      res.code === 200 && resolve(res)
    })
  },
  // 操作员列表
  operatorListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await operatorList(params)
      console.log(data, 'data')
      if (code === 200) {
        commit('save', {
          tableData: data.data,
          pageControl: {
            ...state.pageControl,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 启/禁用管理员状态
  operatorStatusFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await operatorStatus(params)
      res.code === 200 && resolve(res)
    })
  },
  // 编辑管理员
  editOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await editOperator(params)
      console.log(res)
      res.code === 200 && resolve(res)
    })
  },
  // 添加管理员
  addOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await addOperator(params)
      console.log(res)
      res.code === 200 && resolve(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

